module.exports = __webpack_public_path__ + "img/p-guoshoucai.b2028aaa.png";